import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment-timezone';
import { useTranslation } from 'react-i18next';
import { DATE_FORMAT } from 'utils/constants/formats';

const DateFormat = ({ date, time_zone }) => {
  const { t } = useTranslation();

  const renderDate = () => {
    return moment(date)
      .tz(time_zone)
      .calendar({
        sameDay: `[${t('DatesUnits:today')}]`,
        nextDay: `[${t('DatesUnits:tomorrow')}]`,
        nextWeek: DATE_FORMAT,
        lastDay: DATE_FORMAT,
        lastWeek: DATE_FORMAT,
        sameElse: DATE_FORMAT
      });
  };

  if (!date) return null;

  return <span data-testid="date-format">{renderDate()}</span>;
};

DateFormat.defaultProps = {
  time_zone: 'Europe/Madrid'
};

DateFormat.propTypes = {
  date: PropTypes.string.isRequired,
  time_zone: PropTypes.string
};
export default DateFormat;
